const STEPS = [
  { num: "01", icon: "/assets/Nuuma_Design_step-1.png", title: "Konsultacja", desc: "Wypełnij formularz kontaktowy" },
  { num: "02", icon: "/assets/Nuuma_Design_step-2.png", title: "Zestaw", desc: "Kurier dostarcza pakiet pod drzwi" },
  { num: "03", icon: "/assets/Nuuma_Design_step-3.png", title: "Pobranie", desc: "Próbka wymazu lub krwi w Polsce" },
  { num: "04", icon: "/assets/Nuuma_Design_step-4.png", title: "Analiza", desc: "Laboratorium Nuuma w Alicante" },
  { num: "05", icon: "/assets/Nuuma_Design_step-5.png", title: "Wynik", desc: "Raport i omówienie ze specjalistą" },
];

export default function Process() {
  return (
    <section
      id="proces"
      data-testid="process-section"
      className="py-20 lg:py-28 bg-white"
    >
      <div className="nuuma-container">
        <div className="max-w-2xl mb-14">
          <span className="inline-block text-xs font-semibold tracking-[0.2em] uppercase text-nuuma-secondary mb-3">
            Jak to działa
          </span>
          <h2 className="font-display font-bold text-nuuma-primary text-3xl sm:text-4xl lg:text-[2.6rem] leading-[1.15]">
            Prosty proces w 5 krokach
          </h2>
        </div>

        <div className="relative grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-5">
          {/* Connector line - desktop only */}
          <div
            aria-hidden
            className="hidden lg:block absolute top-[34px] left-[10%] right-[10%] h-[2px] bg-gradient-to-r from-nuuma-secondary/20 via-nuuma-secondary/40 to-nuuma-secondary/20"
          />
          {STEPS.map((s, i) => (
            <div
              key={i}
              data-testid={`process-step-${i}`}
              className="relative flex flex-col bg-nuuma-grey100/60 rounded-nuuma-m p-6 hover:bg-nuuma-grey100 hover:shadow-nuuma-s transition-all duration-300 overflow-hidden h-full min-h-[320px]"
            >
              <div className="relative h-[68px] w-[68px] rounded-full bg-white shadow-nuuma-s flex shrink-0 items-center justify-center mb-5 font-display font-extrabold text-nuuma-secondary text-xl border-4 border-white">
                {s.num}
              </div>
              <h4 className="font-display font-bold text-nuuma-primary text-lg mb-1 relative z-10">
                {s.title}
              </h4>
              <p className="text-sm text-nuuma-grey700 leading-relaxed relative z-10">
                {s.desc}
              </p>
              
              {/* Big Icon at the bottom */}
              <div className="mt-auto pt-6 -mx-6 -mb-6 flex justify-center items-end relative z-0">
                <img src={s.icon} alt={`Ikona kroku ${s.num}`} className="w-full h-auto object-contain max-h-[160px] opacity-90 mix-blend-multiply" />
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
